import { BasePutRequest } from './core/basePutRequest';
import * as t from 'io-ts';

export class MarkAsReadRequest extends BasePutRequest<undefined> {
    constructor(public bookingId: string, public contentIdentifier: string) {
        super(`bookings/${bookingId}/mark-as-read`, {}, {contentIdentifier}, t.undefined);
    }
}
